import {Entity} from '../../../components/entity';

export class Expression extends Entity {

  title: string;

  constructor({
                id,
                title,
                translation,
                createdAt, updatedAt
              }: Partial<Expression>) {
    super({id, createdAt, updatedAt});

    this.title = title ?? '';
    this.translation = translation ?? '';
  }

  getNameProperty(): string {
    return 'title';
  }
}
